/**
 *
 * @param {Array<string>} addrArray
 * @returns {string}
 */
export const getFullAddress = (addrArray) => addrArray.filter(Boolean).join(', ');
